// extracted by mini-css-extract-plugin
export var chip = "_a9-0";
export var filterDropdown = "_a9-5";
export var filterItem = "_a9-6";
export var icon = "_a9-1";
export var removeButton = "_a9-3";
export var removeIcon = "_a9-4";
export var separator = "_a9-2";